import { useDispatch } from "react-redux"
import { Actions } from "../actions"
import { Box, Button, Chip, CircularProgress } from '@mui/material'
import styles from './style'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import DownloadIcon from '@mui/icons-material/Download';

export default function MasavExportsArchive({
    onMount, loading, masavExports, masavExportsCount
}) {
    const dispatch = useDispatch()
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const navigate = useNavigate()
    const role = sessionStorage.getItem("userRole")

    useEffect(() => {
        dispatch(Actions.ACTIVE_TAB_CHANGED(11))
        onMount({ page, take: pageSize })
    }, [dispatch])

    useEffect(() => {
        onMount({ page, take: pageSize })
    }, [page, pageSize])

    const columns = [
        {
            field: 'id',
            headerName: 'מזהה',
            width: 80,
            align: 'right',
            headerAlign: 'right'
        },
        {
            field: 'exportDate',
            headerName: 'תאריך ייצוא',
            width: 150,
            align: 'right',
            headerAlign: 'right',
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
            }
        },
        {
            field: 'inquiriesCount',
            headerName: 'מספר פניות',
            width: 120,
            align: 'right',
            headerAlign: 'right'
        },
        {
            field: 'totalAmount',
            headerName: 'סכום כולל',
            width: 130,
            align: 'right',
            headerAlign: 'right',
            valueFormatter: (params) => {
                return `₪${params.value.toLocaleString()}`;
            }
        },
        {
            field: 'status',
            headerName: 'סטטוס',
            width: 130,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const isConfirmed = params.value === 'confirmed';
                return (
                    <Chip
                        icon={isConfirmed ? <CheckCircleIcon /> : <PendingIcon />}
                        label={isConfirmed ? 'אושר' : 'ממתין לאישור'}
                        color={isConfirmed ? 'success' : 'warning'}
                        size="small"
                    />
                );
            }
        },
        {
            field: 'actions',
            headerName: 'פעולות',
            width: 200,
            align: 'center',
            headerAlign: 'center',
            sortable: false,
            renderCell: (params) => (
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={() => navigate(`/masav-exports/${params.row.id}`)}
                    >
                        פרטים
                    </Button>
                    {params.row.status !== 'confirmed' && role !== 'recruiting' && (
                        <Button
                            variant="contained"
                            size="small"
                            startIcon={<FileUploadIcon />}
                            onClick={() => navigate(`/masav-exports/${params.row.id}/upload`)}
                        >
                            העלה אישור
                        </Button>
                    )}
                </Box>
            )
        }
    ];

    return (
        <Box sx={styles.container}>
            <Box sx={styles.header}>
                <Box component="p" sx={styles.title}>
                    ארכיון ייצואים למסב
                </Box>
            </Box>

            <Box sx={styles.tableContainer}>
                {loading ? (
                    <Box sx={styles.loadingContainer}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <DataGrid
                        rows={masavExports || []}
                        columns={columns}
                        pageSize={pageSize}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        rowCount={masavExportsCount}
                        paginationMode="server"
                        onPageChange={(newPage) => setPage(newPage)}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        page={page}
                        loading={loading}
                        disableSelectionOnClick
                        autoHeight
                        sx={styles.dataGrid}
                    />
                )}
            </Box>
        </Box>
    )
}

